// extracted by mini-css-extract-plugin
export default {"wrapper":"hcfIs","infos":"zELRQ","content":"QxhiP","textContainer":"NeOPQ","title":"WYepC","text":"OyWEE"};